// extracted by mini-css-extract-plugin
export default {"Image":"RestaurantAccessModal_Image__uY8Zs","FormWrapper":"RestaurantAccessModal_FormWrapper__4l0O-","EmailLink":"RestaurantAccessModal_EmailLink__ZeOcN"};